<div *ngIf="multiple" class="strong">
  {{ adjustmentInvoice.company?.regularName }}
</div>
<price-line-picker
  [inputList]="adjustmentInvoice.priceLines"
  (output)="emitSave()"
  [showSave]="showSave"
  [savingLines]="savingLines"
  (saveLines)="saveLines.emit()"
></price-line-picker>
